import { WordDocumentTemplate } from '@work4all/models/lib/Classes/WordDocumentTemplate.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { PDFTextmarkConf } from '../../../preview/pdf-textmarks/PDFTextmarkContainer';
import { MIME_TYPES } from '../../../preview/Preview';
import { IDocumentPreviewContainerProps } from '../document-preview';
import { DocumentPreview } from '../document-preview/DocumentPreview';
import { useEntityPreviewData } from '../hooks/use-entity-preview-data';

export interface IDocumentTemplatePreviewContainerProps
  extends Omit<IDocumentPreviewContainerProps, 'documentId'> {
  wordDocumentTemplateId: number;
  pdfTextmarkConf?: PDFTextmarkConf;
  additionalTitleItems?: React.ReactNode;
}

const requestedWordDocumentTemplateData: WordDocumentTemplate<EMode.query> = {
  id: null,
  fileInfos: {
    previewUrl: null,
    previewMimeType: null,
    fileServiceProviderInfos: {
      id: null,
      fileName: null,
      mimeType: null,
      fspUrl: null,
    },
  },
  title: null,
};

export function WordDocumentTemplatePreviewContainer(
  props: IDocumentTemplatePreviewContainerProps
) {
  const {
    wordDocumentTemplateId,
    onCloseClicked,
    onEditClicked,
    pdfTextmarkConf,
    additionalTitleItems,
  } = props;

  const wordDocumentTemplates = useEntityPreviewData<WordDocumentTemplate>(
    [wordDocumentTemplateId],
    Entities.wordDocumentTemplate,
    requestedWordDocumentTemplateData
  );

  if (!wordDocumentTemplates) return null;

  return (
    <DocumentPreview
      title={
        wordDocumentTemplates[0].title ||
        wordDocumentTemplates[0].fileInfos?.fileServiceProviderInfos
          ?.fileName ||
        ''
      }
      url={`${wordDocumentTemplates[0].fileInfos.previewUrl}`}
      mimeType={
        wordDocumentTemplates[0].fileInfos?.previewMimeType as MIME_TYPES
      }
      noPreviewUrl={
        wordDocumentTemplates[0].fileInfos?.fileServiceProviderInfos?.fspUrl ||
        wordDocumentTemplates[0].fileInfos?.downloadUrl
      }
      onCloseClicked={onCloseClicked}
      onEditClicked={onEditClicked}
      pdfTextmarkConf={pdfTextmarkConf}
      additionalTitleItems={additionalTitleItems}
    />
  );
}
